import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-homefive-courses',
  templateUrl: './homefive-courses.component.html',
  styleUrls: ['./homefive-courses.component.scss']
})
export class HomefiveCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
